import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import jMoment from 'moment-jalaali';
import { useNavigate, useParams } from 'react-router-dom';
import { PageContainer, PriceLabel } from 'components';
import { useQuery } from 'hooks';
import { constBreadCrumbsTitle } from 'utility';
import { GUARANTOR_CODE_OPTIONS } from '../constants/Options';
import { useStyles } from './style';
import Serivces from '../services/Services';
import { useCurrencyUnit } from 'hooks';

const FinancialInvoicesDetails = (props) => {
  // -- STATE --//
  const [loan, setLoan] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const currencyText = useCurrencyUnit(false);

  // --HOOKS--//
  const classes = useStyles();
  const navigate = useNavigate();
  const query = useQuery();

  //const isUser = query.get('isUser');
  useEffect(() => {
    getLaonDetail();
  }, []);
  const getLaonDetail = async () => {
    try {
      setLoading(true);
      const res = await Serivces.getLaonDetail(id);
      setLoan(res?.result[0] ?? null);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer
      title="جزئیات قرارداد"
      onBackClick={() => navigate(-1)}
      breadcrumbs={constBreadCrumbsTitle.FINANCIALSUPPLY_INVOICEFINANCING_INVOICES_ID}
      className={classes.root}
      loading={loading}
    >
      <Grid container direction="row" alignItems="center">
        <Grid container direction="row" alignItems="center">
          {loan && (
            <Grid item xs={12}>
              <Grid container className={classes.info}>
                <Grid item xs={12}>
                  <Typography component="h2" style={{ fontSize: '16px' }}>
                    اطلاعات قرارداد
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>نام قرارداد</Typography>
                  <Typography className={classes.detailValue}>
                    {loan?.contract?.name ?? '-'}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>ضامن</Typography>
                  <Typography className={classes.detailValue} style={{ fontFamily: 'Vazir' }}>
                    {GUARANTOR_CODE_OPTIONS.find((o) => o.value === loan?.contract?.guarantor)
                      .label ?? '-'}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>تاریخ ایجاد</Typography>
                  <Typography className={classes.detailValue}>
                    {jMoment(loan?.contract?.creationDate).format('HH:mm - jYYYY/jMM/jD') ?? '-'}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>تاریخ پایان</Typography>
                  <Typography className={classes.detailValue}>
                    {jMoment(loan?.contract?.endDate).format('HH:mm - jYYYY/jMM/jD') ?? '-'}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>وضعیت</Typography>
                  <Typography className={classes.detailValue}>
                    {loan?.contract?.active ? 'فعال' : 'غیرفعال'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography component="h2" style={{ fontSize: '16px', marginTop: '2em' }}>
                    اطلاعات اعتبار کاربر
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>اعتبار کاربر</Typography>
                  <Typography className={classes.detailValue}>
                    <PriceLabel amount={loan?.amount} />
                    <span className={classes.priceLabel}>{currencyText}</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>میزان مصرف شده</Typography>
                  <Typography className={classes.detailValue}>
                    = <PriceLabel amount={loan?.amount - loan?.remainingAmount} />
                    <span className={classes.priceLabel}>{currencyText}</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4} className={classes.detail}>
                  <Typography className={classes.detailTitle}>میزان باقی مانده</Typography>
                  <Typography className={classes.detailValue}>
                    <PriceLabel amount={loan?.remainingAmount} />
                    <span className={classes.priceLabel}>{currencyText}</span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default FinancialInvoicesDetails;
